module.exports = "<div class=\"row\"><div class=\"col s12 dialog-content\"><p class=\"error-message\">{{ data.error || 'Ocurrió un error al obtener los datos' }}</p></div><div class=\"col s12 dialog-footer center-align\"><button class=\"btn\" (click)=\"onNoClick()\" aria-label=\"Cerrar\">Cerrar</button></div></div>"


//////////////////
// WEBPACK FOOTER
// ./src/app/dialogs/error-catch-dialog/error-catch-dialog.component.html
// module id = ./src/app/dialogs/error-catch-dialog/error-catch-dialog.component.html
// module chunks = main